import {getRandom} from "./gerRandom";

export const  generateAIDiagramData = (quantity: number, range: [number, number]): (number | string)[][] => {
    const [min, max] = range;
    
    const names = [ "Data for Reanalysis", "Market Analysis", "Forecast Scenarios"];
    
    return Array.from({
        length: quantity
    }, () => [
        getRandom(max, min), getRandom(max, min), getRandom(max, min), getRandom(max, min),
        getRandom(max, min), getRandom(max, min), getRandom(max, min), names[getRandom(names.length, 0 )]
    ]);
};
